import { EmailTypeEnum } from '@/types/email.types';
import { EmailContent } from '../scheduled-emails/event-email';

interface IEditableTextContent {
  salutation: string;
  projectName: string;
  projectDescription: string;
  projectStart: string;
  projectStartTime?: string;
  emailContent: EmailContent;
  emailType: EmailTypeEnum;
  hideCalendar?: boolean;
}

export const getDefaultPlainTextProjectEmail = (data: IEditableTextContent) => {
  const salutationSplit = data.salutation.split(',');
  const salutation = salutationSplit?.[0] || '';
  const registeredForEvent = (salutationSplit?.[1] || '').trimLeft();

  const buttonTextKey =
    data.emailType !== EmailTypeEnum.event_registration_email && data.emailContent?.event?.registrationRequired
      ? 'RegisterNow'
      : 'ExploreEvent';
  const buttonText = data.emailContent.translations[buttonTextKey];

  return `${salutation},\n\n${registeredForEvent} ${data.projectName}\n\n${data.projectDescription}\n\n${data.projectStart} ${data.projectStartTime}\n\n${buttonText}: event_url`;
};
